/**
 * 删除对象中的指定key
 * @param object 待删除的对象
 * @param keys 需要删除的keys
 */
export const deleteObjKeys = (object: Record<string, any>, keys: string[]): Record<string, any> => {
  const obj = { ...object };
  const objKeys = Object.keys(obj);
  keys.forEach((key) => {
    if (objKeys.findIndex((objKey) => objKey === key) > -1) {
      delete obj[key];
    }
  });

  return obj;
};
